import { Loading } from "../../../utils";
import { useSelector } from "react-redux";
import ExportSelectedRows from "../../ExportCSV";
import React, { useState, useEffect } from "react";
import WrapIcon from "../../../assets/images/wrap-icon.png";
import filter from "../../../assets/images/filter.svg";
import BlueFilterIcon from "../../../assets/images/BlueFilterIcon.svg";
import searchMyProjects from "../../../assets/images/searchMyProjects.svg";
import exapandCollapseAll from "../../../assets/images/expandCollapseAll.svg";
import searchMyProjectsClicked from "../../../assets/images/searchMyProjectsClicked.svg";
import uploadIcon from "../../../assets/images/upload.svg";
import { ADDITIONAL_FILE_UPLOAD_ROLES } from "../../../constants/FileUploadConstant";
import "./index.scss";

const FilesFolderHeader = ({
  isSearch = false,
  header,
  allData,
  headers,
  filename,
  clearFilter,
  selectedRows,
  expandedKeys,
  onSearchClick,
  isTreeTableFlag,
  projectPlanView,
  setClearGlobalFilter,
  isGlobalFilterActivated,
  setGlobalFilterActivated,
  removeAllFiltersSortAndFreeze,
  handleExapandCollapseAllButton,
  onChildClick,
  wrapFilename,
  setWrapFilename,
  showFileUploadPopup,
  setShowFileUploadPopup,
}) => {
  let modifiedAllData = allData;
  if (isTreeTableFlag) {
    modifiedAllData = allData?.map((obj) => obj.data);
  }
  const [loading, setLoading] = useState(false);
  const [isUploadClicked, setIsUploadClicked] = useState(false);

  const {
    userDetails: { AccessGroup },
  } = useSelector((state) => state?.UserDetailsReducer);
  const roleFormat = () => {
    return AccessGroup?.map((role) => {
      return role?.AccessGroupNames?.substr(4);
    });
  };
  const userDetailsInformation = roleFormat();
  const hasUploadPermission = userDetailsInformation?.some((role) =>
    ADDITIONAL_FILE_UPLOAD_ROLES?.includes(role),
  );
  const handleLoading = () => {
    setLoading(true);
  };

  const handleUploadClick = () => {
    setIsUploadClicked(true);
    if (setShowFileUploadPopup) {
      setShowFileUploadPopup(true);
    }
  };

  const [isClicked, setIsClicked] = useState(isSearch);
  const [isfilterClicked, setIsFilterClicked] = useState(false);

  const handleClick = () => {
    const newIsClicked = !isClicked;
    setIsClicked(newIsClicked);
    onSearchClick();
    if (onChildClick) {
      onChildClick(newIsClicked);
    }
  };

  const handleClearFilter = () => {
    const newIsClicked = !isGlobalFilterActivated;
    setIsFilterClicked(newIsClicked);
    setIsClicked(newIsClicked);
    removeAllFiltersSortAndFreeze();
    if (onChildClick) {
      onChildClick(newIsClicked);
    }
  };

  useEffect(() => {
    if (loading) {
      handleExapandCollapseAllButton();
      setLoading(false);
    }
  }, [loading]);
  return (
    <div className="actions" style={{ paddingRight: 42 }}>
      <div className="project-title">{header}</div>

      <div className="action-buttons">
        {projectPlanView && (
          <>
            {loading ? (
              <Loading />
            ) : (
              <>
                <img
                  src={exapandCollapseAll}
                  onClick={() => handleLoading()}
                  data-pr-tooltip="Expand/Collapse All"
                  className={`expand-collapse ${
                    expandedKeys?.length !== 0 ? "invertedIcon" : "nonInvertedIcon"
                  }`}
                  alt=""
                />
                <img
                  hidden={""}
                  alt="filter logo"
                  className="header-icons"
                  onClick={() => handleClearFilter()}
                  src={isGlobalFilterActivated ? BlueFilterIcon : filter}
                />
                <img
                  alt="search field"
                  onClick={handleClick}
                  className="header-icons"
                  src={isClicked ? searchMyProjects : searchMyProjectsClicked}
                />
                <ExportSelectedRows
                  headers={headers}
                  filename={filename}
                  selectedRows={selectedRows}
                  allData={!selectedRows?.lenght && allData}
                />
                <img
                  src={WrapIcon}
                  alt={wrapFilename ? "Unwrap Filename" : "Wrap Filename"}
                  title={wrapFilename ? "Unwrap Filename Column" : "Wrap Filename Column"}
                  style={{
                    width: "20px",
                    height: "20px",
                    cursor: "pointer",
                    filter: wrapFilename ? "none" : "grayscale(100%)",
                  }}
                  onClick={() => setWrapFilename((prev) => !prev)}
                />
                {hasUploadPermission && (
                  <button
                  type="button"
                  className={"btn btn-primary reset-to-default-view"}
                  onClick={() => {
                    handleUploadClick();
                  }}
                  title="Upload Additional File(s)"
                >
                  Upload File
                </button>
              )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default FilesFolderHeader;
